
import { doGet, doPost, doDelete, doPut } from './Api';

export default class CategoryService {

  static async responseGetCategory () {
    const response = await doGet(`${process.env.REACT_APP_BASE_URL}/Category/`);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubó un error al cargar';
    }
  }

  static async responseSaveCategory (newCategory) {
    const response = await doPost(`${process.env.REACT_APP_BASE_URL}/Category`,{...newCategory});
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubó un error al guardar';
    }
  }

  static async responseDeleteCategory (id) {
    const response = await doDelete(`${process.env.REACT_APP_BASE_URL}/Category/${id}`);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubó un error al actualizar';
    }
  }

  static async responseUpdateCategory (id, data) {
    const response = await doPut(`${process.env.REACT_APP_BASE_URL}/Category/${id}`, data);
    if(response.data.success){
      return response.data;
    }else{
      throw 'Hubó un error al eliminar';
    }
  }

}
